import React from 'react';
import Hero, { HeroProps } from './Hero';
import SuccessHeaderBlueSvg from './SuccessHeaderBlueSvg';

export const SuccessHeaderBlue: React.FunctionComponent<HeroProps> = (props) => {
    return (
        <Hero {...props}>
            <SuccessHeaderBlueSvg />
        </Hero>
    );
};

SuccessHeaderBlue.displayName = 'SuccessHeaderBlue';
